import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

import type { ChainHealth } from './types';

type Props = {
  chains: ChainHealth[];
};

/** One row per chain: who serves its reads, and whether they answered, with the provider's message when not. */
export function ChainHealthTable({ chains }: Props) {
  const { t } = useTranslation('manageCryptoPayments');

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>{t('chainHealth.columns.chain')}</TableHead>
          <TableHead>{t('chainHealth.columns.provider')}</TableHead>
          <TableHead>{t('chainHealth.columns.result')}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {chains.map((chain) => (
          <TableRow key={chain.chainId}>
            <TableCell className="whitespace-nowrap align-top">{chain.name}</TableCell>
            <TableCell className="align-top">
              <span className="block text-sm">{chain.provider}</span>
              <span className="text-muted-foreground block font-mono text-xs">{chain.endpoint}</span>
            </TableCell>
            <TableCell className="align-top">
              {chain.ok ? (
                <span className="inline-flex items-center gap-2">
                  <Badge variant="green">{t('chainHealth.ok')}</Badge>
                  <span className="text-muted-foreground text-xs">
                    {t('chainHealth.latency', { ms: chain.latencyMs })}
                  </span>
                </span>
              ) : (
                <span className="flex flex-col items-start gap-1">
                  <Badge variant="red">{t('chainHealth.failing')}</Badge>
                  <span className="text-destructive break-all text-xs">{chain.error}</span>
                </span>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
